@if (visible) {
  <div
    class="loading-badge"
    role="status"
    aria-live="polite"
    [attr.aria-label]="ariaLabelKey ? (ariaLabelKey | translate) : null"
    >
    <div class="loading-badge__panel">
      <span class="loading-badge__ring"></span>
      <span class="loading-badge__bar"></span>
      <span class="loading-badge__text">
        {{ textKey ? (textKey | translate) : (textFallbackKey ? (textFallbackKey | translate) : '') }}
      </span>
    </div>
  </div>
}

